import React, { useMemo }from 'react';
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { type ColDef, themeAlpine } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 100%;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    height: string;
    attributeType: string;
    setApplyEnabled: (value: boolean) => void;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    height,
    attributeType,
    setApplyEnabled,
}) => {
    const onSelectionChanged = (params) => {
        apiProvider.setAttributeFilter({ selection: params.api.getSelectedRows() });
        setApplyEnabled(false);
    };
   
    const onRowDataChanged = (params) => {
        if (attributeType === 'Event') {
            params.api.applyColumnState({ state: [{ colId: 'avg_duration', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'events', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_total_tasks', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_total_events', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_compliant_tasks', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_compliant_events', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_automated_tasks', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_automated_events', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'std_deviation', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'tasks', hide: false }] });
            if (apiProvider.getEventAttributeFilterGridState() != null) params.api.applyColumnState(apiProvider.getEventAttributeFilterGridState());
        }
        if (attributeType === 'Task') {
            params.api.applyColumnState({ state: [{ colId: 'avg_duration', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'events', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_total_tasks', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_total_events', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_compliant_tasks', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_compliant_events', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_automated_tasks', hide: false }] });
            params.api.applyColumnState({ state: [{ colId: 'perc_automated_events', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'std_deviation', hide: true }] });
            params.api.applyColumnState({ state: [{ colId: 'tasks', hide: false }] });
            if (apiProvider.getTaskAttributeFilterGridState() != null) params.api.applyColumnState(apiProvider.getTaskAttributeFilterGridState());
        }
    };

    const onSaveGridColumnState = (params) => {
        let columnState = params.api.getColumnState();
        if (attributeType === 'Event') {
            apiProvider.saveEventAttributeFilterGridState({columnState})
        } else {
            apiProvider.saveTaskAttributeFilterGridState({columnState})
        }
    }
    
    const onFilterChanged  = (params) => {
        onSaveGridColumnState(params)
    }
    const onColumnVisible  = (params) => {
        onSaveGridColumnState(params)
    }
    const onColumnResized  = (params) => {
        onSaveGridColumnState(params)
    }
    const onSortChanged  = (params) => {
        onSaveGridColumnState(params)
    }

    const enableCharts = true;
    const getRowHeight = () => 25;

    return (
        <Wrapper height={height}>
            <div
                
                style={{
                    height: '100%',
                    width: '100%',
                    fontSize: '12px',
                    fontFamily: 'system-ui'
,
                }}
            >
                <AgGridReact theme={themeAlpine} 
                    rowSelection="multiple"
                    onSelectionChanged={onSelectionChanged}
                    onRowDataChanged={onRowDataChanged}
                    getRowHeight={getRowHeight}

                    onFilterChanged={onFilterChanged}
                    onColumnVisible={onColumnVisible}
                    onColumnResized={onColumnResized}
                    onSortChanged={onSortChanged}    

                    columnDefs={columns}
                    headerHeight={40}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        resizable: true,
                        autoHeight: true,
                        wrapText: true,
                    }}
                    rowData={rows}
                    sideBar={
                        {
                            toolPanels: [
                                {
                                    id: 'columns',
                                    labelDefault: 'Columns',
                                    labelKey: 'columns',
                                    iconKey: 'columns',
                                    toolPanel: 'agColumnsToolPanel',
                                    toolPanelParams: {
                                        suppressRowGroups: true,
                                        suppressValues: true,
                                        suppressPivotMode: true, 
                                    }
                      
                                },
                                {
                                    id: 'filters',
                                    labelDefault: 'Filters',
                                    labelKey: 'filters',
                                    iconKey: 'filter',
                                    toolPanel: 'agFiltersToolPanel',
                                },
                            ],
                            hiddenByDefault: false,
                            defaultToolPanel: '',
                        }
                    }
                    enableCharts={enableCharts}
                    chartThemes={[
                        'ag-solar',
                        'ag-pastel',
                        'ag-material-dark',
                        'ag-vivid-dark',
                    ]}
                />
            </div>
        </Wrapper>
    );
};
